//react
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ReactGA from 'react-ga';

//data
import dataSiteMap from '../../siteMap.json';

//assets
import './materials.css';

//functions
import * as Utilities from '../../utilities';

class Materials extends Component {
	trackView(action, label) {
		ReactGA.event({
			category: 'material',
			action: action,
			label: label,
		});
	}

	render() {
		const data = this.props.data;
		const cultureFallback = 'uk'; //UK set as the default culture
		let cultureRequested = cultureFallback;
		let title = null;
		let items = null;
		let buttonLabelView = '';
		let buttonLabelDownload = '';

		const userAgent = window.navigator.userAgent;
		let showDownload = true;

		if (userAgent.indexOf('MSIE ') >= 0 || userAgent.indexOf('Trident/') >= 0) {
			showDownload = false;
		}

		if (data) {
			//get culture if one requested
			if (this.props.culture) {
				if (data[this.props.culture]) {
					cultureRequested = this.props.culture;
				}
			}

			//get content for requested culture
			if (data[cultureRequested][this.props.name]) {
				if (data[cultureRequested][this.props.name].title) {
					title = data[cultureRequested][this.props.name].title;
				}

				if (data[cultureRequested][this.props.name].items) {
					items = data[cultureRequested][this.props.name].items;
				}

				if (data[cultureRequested][this.props.name].buttonLabelView) {
					buttonLabelView = data[cultureRequested][this.props.name].buttonLabelView;
				}

				if (data[cultureRequested][this.props.name].buttonLabelDownload) {
					buttonLabelDownload = data[cultureRequested][this.props.name].buttonLabelDownload;
				}
			}

			//if no content for requested culture get content for fallback culture
			if (!title || !items) {
				if (!title && data[cultureFallback][this.props.name].title) {
					title = data[cultureFallback][this.props.name].title;
				}

				if (!items && data[cultureFallback][this.props.name].items) {
					items = data[cultureFallback][this.props.name].items;
				}
			}
		}

		if (!items) {
			return null;
		}

		const materialsTitle = () => {
			if (title) {
				return (
					<h2 className="materials__title">{Utilities.removeWidow(title)}</h2>
				);
			}
		}

		const materialsList = items.map((record, index) => {
			return (
				<div className="materials__item" key={index}>
					<div className="container__row">
						<div className="container__column container__column--top materials__item__image-column">
							<Link className="materials__item__link hwa" onClick={() => this.trackView('view', record.filePath)} rel="noopener" target="_blank" to={process.env.PUBLIC_URL + record.filePath}>
								<img alt={record.title} height={record.imageDimentions.height} src={process.env.PUBLIC_URL + record.imagePath} width={record.imageDimentions.width} />
							</Link>
						</div>
						<div className="container__column container__column--top">
							<h3 className="materials__item__title">{Utilities.removeWidow(record.title)}</h3>
							<p>{Utilities.removeWidow(record.body)}</p>
							<Link className="materials__item__button hwa" hrefLang={dataSiteMap[this.props.culture].cultureCode} onClick={() => this.trackView('view', record.filePath)} rel="noopener" target="_blank" to={process.env.PUBLIC_URL + record.filePath}>{buttonLabelView}</Link>
							{showDownload &&
								<a className="materials__item__button hwa" download href={process.env.PUBLIC_URL + record.filePath} hrefLang={dataSiteMap[this.props.culture].cultureCode} onClick={() => this.trackView('download', record.filePath)}>{buttonLabelDownload}</a>
							}
						</div>
					</div>
				</div>
			);
		});

		return (
			<div className="materials">
				{materialsTitle()}
				{materialsList}
			</div>
		);
	}
}

export default Materials;



// WEBPACK FOOTER //
// ./src/components/materials/materials.js